export const roleTemplateFormMessages = {
  // Form labels and placeholders
  titleLabel: 'Title',
  titlePlaceholder: 'Enter role template title',
  descriptionLabel: 'Description',
  descriptionPlaceholder: 'Enter role template description',

  // Button text
  createTemplateButton: 'Create Role Template',
  cancelButton: 'Cancel',
  creating: 'Creating...',

  // Form accessibility
  formAriaLabel: 'Create role template form',

  // Validation messages
  titleRequired: 'Title is required',
  descriptionRequired: 'Description is required',
} as const;
